'use client';

import { PageLoadingOverlay } from '@sprd/sprd-component-kit/v2';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { loadingOverlayAtom } from '@/store/atoms';

export const LoadingOverlayWrapper = () => {
  const showOverlay = useAtomValue(loadingOverlayAtom);
  const t = useTranslations();
  return (
    <PageLoadingOverlay
      isShown={showOverlay}
      delay={100}
      animationDuration={100}
      aria-label={t('general.a11y.loading')}
    />
  );
};
